import { render, staticRenderFns } from "./punkstar.vue?vue&type=template&id=a09b163c"
import script from "./punkstar.vue?vue&type=script&lang=js"
export * from "./punkstar.vue?vue&type=script&lang=js"
import style0 from "./punkstar.vue?vue&type=style&index=0&id=a09b163c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports